import styled from 'styled-components';

export const Radius = styled.div`
    border-radius: 20px;
    padding: 0px 20px 0px 20px;
    color: var(--white);
    background: var(--white);
    display: flex;
    align-items: center;
    width: 100%;
    height: 40px;
    border: 1px solid rgb(51, 51, 51);
    background-color: rgb(255, 255, 255);
    margin-top: 0em;

    body {
        font-family: Roboto, sans-serif;
        font-size: 18px;
        color: rgb(51, 51, 51);
        -webkit-font-smoothing: antialiased !important;
    }

    input {
        box-shadow: 0 0 0 0;
        border: 0 none;
        outline: 0;
    }

    button {
        border: none;
        background-color: var(--white);
    }
`;
